import _ from "lodash";

const COMMAND_GET_SMART_MODE = "commands/getSmartModeSettings";
const EVENT_SMART_MODE_UPDATE = "events/smartModeUpdate";

// Expected data structure:
// smartModeSettings: {
//   [tstatGuid]: {
//     active: [bool],
//     temperature: [number],
//   }
// }
const getInitState = () => ({
	smartModeSettings: {},
});

export default {
	namespaced: false,
	state: getInitState(),

	getters: {
		smartModeSettings(state) {
			return state.smartModeSettings;
		},
	},

	mutations: {
		setSmartModeSetting(state, { guid, smartModeSettings }) {
			state.smartModeSettings = {
				...state.smartModeSettings,
				[guid]: smartModeSettings,
			};
		},
	},

	actions: {
		// Model changed, get new thermostat information
		modelChanged: {
			root: true,
			handler({ commit, dispatch, getters }, { initialConnection }) {
				// Only perform check on *first* connection to controller, not
				// every time the model changes.
				if (!initialConnection) return;

				const actionServer = getters.actionServer;
				const tstats = getters.thermostats;
				if (!actionServer || _.isEmpty(tstats)) {
					return;
				}

				_.each(tstats, tstat => {
					const thermostatPath = tstat.path;
					dispatch("executeCommand", {
						node: actionServer,
						subpath: COMMAND_GET_SMART_MODE,
						commandParams: { thermostatPath },
					}).then(resp => {
						// We need to remap the response, since the
						// `getSmartModeSettings` command returns more data with
						// slightly different keys than the `smartModeUpdate` event
						commit("setSmartModeSetting", {
							guid: tstat.meta.guid,
							smartModeSettings: {
								active: resp.active,
								temperature: resp.target,
							},
						});
					});
				});
			},
		},

		// Captured unhandled event fired on K4 model. Check if it's a smart
		// mode change and update thermostat information accordingly.
		modelEventFired: {
			root: true,
			handler({ commit, getters }, { event, data }) {
				if (!_.endsWith(event, EVENT_SMART_MODE_UPDATE)) return;

				this._vm.$log(`Smart mode settings updated: ${JSON.stringify(data)}`);

				const { active, thermostatPath } = data;
				const guid = getters.liveNodeByPath(thermostatPath).guid();
				if (active) {
					commit("setSmartModeSetting", {
						guid,
						smartModeSettings: {
							active,
							temperature: data.temperature,
						},
					});
				} else {
					commit("setSmartModeSetting", {
						guid,
						smartModeSettings: { active },
					});
				}
			},
		},
	},
};
